import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../utils/config';
import Sidebar from '../components/sidebar';
import TelegramWidget from '../components/widget/telegramWidget';
import HeartbeatTable from '../components/dashboard/heartbeatTable';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const HeartbeatMonitor = () => {
    const [HeartbeatData, setHeartbeatData] = useState([]);
    let count = 0;
  const [errorDialog,setErrorDialog]=useState(false);
  const [errorMessage,setErrorMessage]=useState("");
    useEffect(() => {
        if (count === 0) {
            fetchHeartbeatMonitorData();
            count += 1;
        }
    },[]);

    const fetchHeartbeatMonitorData = async () => {
        try {
            await fetch(`${BASE_URL}/heartBeatMonitorData/`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(res => {

                    if (res.success === true) {
                        setHeartbeatData(res.data);
                    } else {
                        console.log("data not found");
                        setErrorMessage(`Error: ${res.message}`);
                        setErrorDialog(true)
                        setTimeout(() => {
                          setErrorDialog(false)
                          setErrorMessage("")
                          }, 1700);
                    }

                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setErrorMessage(`Error: ${error.message}`);
                    setErrorDialog(true)
                    setTimeout(() => {
                      setErrorDialog(false)
                      setErrorMessage("")
                      }, 1700);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
            setErrorMessage(`Error: ${error.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
        }
    };


    return (
        <div>
            <Sidebar />
            <div className='Dashboard-container'>
                <HeartbeatTable Record={HeartbeatData} heading={'Heartbeat Monitor'} />
                <TelegramWidget/>
                 {/*Error Message Dialog */}
                            <Dialog
                        open={errorDialog}
                        onClose={()=>{setErrorDialog(false)}}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle  id="alert-dialog-title">
                        <h4 style={{ color: "red" }}>Failure</h4>
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                           
                                 
                            {errorMessage}
                             
                          
                          </DialogContentText>
                        </DialogContent>
                       
                            </Dialog>
            </div>
        </div>
    );
};

export default HeartbeatMonitor;
